// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ActiveStatus } from './active-status';
import { Program } from './program';
import { ProgramRequirementSource } from './program-requirement-source';
import { ProximityUser } from './proximity-user';
import { ActiveStatusEnum } from './enums';
import { ProgramRequirementSourceEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProgramRequirement extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Enum FK activeStatus */
  activeStatusId!: ActiveStatusEnum;
  /** Guid FK createdByUser */
  createdByUserId!: string;
  /** DateTimeOffset */
  crtnTs!: Date;
  /** Int32 */
  displayOrder!: number;
  /** Guid FK program */
  programId!: string;
  /** Enum FK programRequirementSource */
  programRequirementSourceId!: ProgramRequirementSourceEnum;
  /** Binary */
  rowVersion!: any;
  /** String */
  text!: string;
  /** FK activeStatusId */
  activeStatus!: ActiveStatus;
  /** FK createdByUserId */
  createdByUser!: ProximityUser;
  /** FK programId */
  program!: Program;
  /** FK programRequirementSourceId */
  programRequirementSource!: ProgramRequirementSource;
}

